import React from 'react';
import { MotionConfig } from 'framer-motion';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AutoGallery } from './components/AutoGallery';
import { Motivations } from './components/Motivations';
import { HowItWorks } from './components/HowItWorks';
import { CreationsGallery } from './components/CreationsGallery';
import { MainGuide } from './components/MainGuide';
import { Bonuses } from './components/Bonuses';
import { TemplateLibrary } from './components/TemplateLibrary';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { tricotinGallery } from './data/galleries';
import { siteConfig } from './data/siteConfig';
import { useDocumentMeta } from './hooks/useDocumentMeta';
import { useMetaPixel } from './hooks/useMetaPixel';
type AppProps = {
  /** Werkweergave: toont inhoud die nog bevestigd moet worden, met labels. */
  draftPreview?: boolean;
};
export function App({
  draftPreview = true
}: AppProps) {
  useDocumentMeta(siteConfig.pageTitle, siteConfig.pageDescription, 'nl-NL');
  useMetaPixel(siteConfig.metaPixelId);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="67yvnd9206b">
      <div className="min-h-screen w-full [overflow-x:clip] bg-cream font-sans text-ink selection:bg-berry-deep selection:text-white" data-id="element-1" data-mp="56m9egl55mh">
        <AnnouncementBar data-id="element-2" data-mp="33mf25srr5vek" />
        <Header data-id="element-3" data-mp="33nq6btp41567" />
        <main id="inhoud" data-id="element-4" data-mp="33ngiabnml835">
          <Hero draftPreview={draftPreview} data-id="element-5" data-mp="33orla998ybt7" />
          <AutoGallery items={tricotinGallery} label="Voorbeelden van creaties met punnikkoord" data-id="element-6" data-mp="38li7lebna3n2" />
          <Motivations data-id="element-7" data-mp="3dl4l7ovdxlwe" />
          <HowItWorks data-id="element-8" data-mp="3dmfq5s0kgzp3" />
          <CreationsGallery data-id="element-9" data-mp="3dirw8rr7mb9u" />
          <MainGuide data-id="element-10" data-mp="nvstj3irmlvf" />
          <Bonuses data-id="element-11" data-mp="nuhg0bzipzr4" />
          <TemplateLibrary data-id="element-12" data-mp="nv0ybtt2yq5o" />
          <AutoGallery items={tricotinGallery} label="Meer ideeën voor creaties met punnikkoord" data-id="element-13" data-mp="nxwwnj8ubgun" />
          <Testimonials draftPreview={draftPreview} data-id="element-14" data-mp="swgk5o3310p4" />
          <Offer data-id="element-15" data-mp="35gmx6tbedlm" />
          <FAQ data-id="element-16" data-mp="34x29ica5b3w" />
        </main>
        <Footer data-id="element-17" data-mp="38b2ol1dva8p" />
      </div>
    </MotionConfig>;
}